import styled, { css } from 'styled-components';

import { getFontStyle } from '../../utils';

export const StyledAnimatedText = styled.div`
  ${({ theme }) => css`
    display: flex;
    background-color: ${theme.Color.Neutrals.Paper};
    justify-content: center;
    align-items: center;

    & span {
      ${getFontStyle('LargeTitle')};
    }

    @media (min-width: ${theme.Screen.Size.XSmall}px) {
      & span {
        ${getFontStyle('HugeTitle')};
      }
    }

    @media (min-width: ${theme.Screen.Size.Small}px) {
      & span {
        ${getFontStyle('HugeTitleBold')};
      }
    }
  `}
`;

export const StyledAnimatedTextTitleAnimated = styled.div<{
  gradient?: string;
}>`
  ${({ gradient }) => `
    & span:first-child {
      line-height: normal !important;
      background-image: linear-gradient(${gradient});
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  `}
`;
